import React, { createContext, useState, useEffect } from 'react';

export const WDWContext = createContext();

export const WDWProvider = ({ children }) => {
  // Cette fonctionnalité est maintenant publique par défaut
  // Les parcs WDW sont toujours visibles pour tous les utilisateurs
  const [showWDW, setShowWDW] = useState(true);

  // Sauvegarder l'état dans le localStorage à chaque changement
  // Conservé pour compatibilité avec le code existant
  useEffect(() => {
    localStorage.setItem('showWDW', JSON.stringify(showWDW));
  }, [showWDW]);

  const toggleWDW = () => {
    setShowWDW(prevState => !prevState);
  };

  return (
    <WDWContext.Provider value={{ showWDW, toggleWDW }}>
      {children}
    </WDWContext.Provider>
  );
};
